const mutations = {
  LOGIN(state, data) {
    state.isLogin = true;
    localStorage.setItem("accesstoken", data);
  },
  LOGOUT(state) {
    state.isLogin = false;
    state.isAdmin = false;
    state.email = "";
    state.mobileNo = "";
    state.username = "";
    state.id = null;
    state._id = null;
    localStorage.removeItem("adminType");
    localStorage.removeItem("plannerId");
    localStorage.removeItem("accesstoken");
  },
  SET_NAVBAR(state, data) {
    state.navbarState = data;
  },
  SET_NAVBAR_VISIBLE(state, data) {
    state.navVisible = data;
  },
  SET_FOOTER(state, data) {
    state.footerVisible = data.visible;
  },
  SET_QNA_COUNT(state, data) {
    state.qnaCount = data.qna;
    state.patnershipCount = data.partnership;
  },
  SET_CONSULT_COUNT(state, data) {
    state.consultCount = data;
  },

  SET_USER_INFO(state, data) {
    if (data.email) {
      state.email = data.email;
    }

    if (data._id) {
      state._id = data._id;
    }

    if (data.avatar) {
      state.avatar = data.avatar;
    }

    if (data.isAdmin) {
      state.isAdmin = data.isAdmin;
    }
    if (data.mobileNo) {
      state.mobileNo = data.mobileNo;
    }
    if (data.status) {
      state.status = data.status;
    }

    if (data.username) {
      state.username = data.username;
    }

    if (data.userType) {
      state.userType = data.userType;
    }
    if (data.adminType) {
      localStorage.setItem("adminType", data.adminType);
    }
    if (data.plannerId) {
      localStorage.setItem("plannerId", data.plannerId);
    }
  },
};
export default mutations;
